import { DomainSheet } from "@/components/domain";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(departments)/departments/_sheet")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  return <DomainSheet onClose={() => navigate({ to: "/departments" })} />;
}
